import { render, staticRenderFns } from "./SafeCenter.vue?vue&type=template&id=b631f24a&scoped=true"
import script from "./SafeCenter.vue?vue&type=script&lang=js"
export * from "./SafeCenter.vue?vue&type=script&lang=js"
import style0 from "./SafeCenter.vue?vue&type=style&index=0&id=b631f24a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b631f24a",
  null
  
)

export default component.exports